module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 member member-form"
  }, [_vm._m(0), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-info-member"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "info-img"
  }, [(_vm.key_avatar === '' || _vm.key_avatar === null) ? _c('img', {
    staticClass: "img responsive",
    attrs: {
      "src": require('../../assets/images/faces/ic_AvatarDefault.svg')
    }
  }) : _c('img', {
    staticClass: "img responsive",
    attrs: {
      "src": _vm.key_avatar
    }
  })]), _c('div', {
    staticClass: "info-detail"
  }, [_c('span', {
    staticClass: "fullname"
  }, [_vm._v(_vm._s(_vm.key_fullname))]), _c('span', {
    staticClass: "fa fa-comment",
    on: {
      "click": _vm.chatBox
    }
  }, [_c('abbr', [_vm._v("Chat ngay")])])]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ngày tham gia đầu tiên:")]), _c('span', [_vm._v(_vm._s(_vm.key_date_join))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Người duyệt tham gia:")]), _c('span', [_vm._v(_vm._s(_vm.key_user_approval))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ngày cập nhật:")]), _c('span', [_vm._v(_vm._s(_vm.key_date_update))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Người cập nhật:")]), _c('span', [_vm._v(_vm._s(_vm.key_user_update))])])]), _c('div', {
    staticClass: "box-public-member"
  }, [_c('label', {
    staticClass: "title-note"
  }, [_vm._v("Chọn các Cộng đồng bạn muốn mời các thành viên trên tham gia")]), _vm._l((_vm.lstPCs), function(item, index) {
    return (_vm.lstPCs !== null && _vm.lstPCs.length > 0) ? _c('div', [(item.classes.length > 0) ? _c('templateItem', {
      key: _vm.keyIncrement,
      attrs: {
        "item": item
      },
      on: {
        "onClickChecked": _vm.onClickChecked
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('button', {
    staticClass: "active",
    on: {
      "click": _vm.saveUserToPC
    }
  }, [_vm._v("Lưu thay đổi")]), _c('button', {
    on: {
      "click": _vm.cancelRequest
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Chỉnh sửa thành viên")]), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title-note"
  }, [_vm._v("THÀNH VIÊN CẦN CHỈNH SỬA")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a673901","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/edit.vue
// module id = 1549
// module chunks = 0